define('lq/domainDefinitions',[], function () {
    'use strict';

    var DomainDefinitions = function () {
        this.entityDefinitions = [];
        this.indexDefinitions = [];
        this.styles = [];
    };
    
    DomainDefinitions.prototype.getDocumentEntityNames = function () {
        return _.pluck(this.getDocumentEntityDefinitions(), 'name');
    };

    DomainDefinitions.prototype.getDocumentEntityDefinitions = function () {
        return _.filter(this.entityDefinitions, function (entity) {
            return entity.entityType === 'Licquid.Core.LicquidDocumentEntity' ||
                entity.entityType === 'Licquid.Core.LicquidVersionedDocumentEntity';
        });
    };

    return new DomainDefinitions();

});
